import $ from 'jquery';
import AICampusFooter from '@/components/probaworkflows_base_components/AICampusFooter/AiFooter.vue';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import 'datatables.net';
import axios from "axios";
import {
  VIEW_ENTITY_TYPE_URL,
  get_headers,
  get_project_id
} from '@/utils/constants/constants.js';

export default {
  name: 'ComplianceManagement',
  components: { AICampusFooter },
  data: () => ({
    headers: get_headers(),
    project_id: get_project_id(),
    entity_types: [],
    entity_types_loading: false,
    selected_status: 'Compliant',
    data_table: null
  }),

  computed: {
    filtered_table_data() {
      return this.entity_types.map(entity => ({
        'Application No': entity.id,
        'Founder Name': entity.entity_type_name,
        'Date Created': entity.date_created,
        'Status': this.selectedStatus,
        'entity': entity
      }));
    },
    compliant_count() {
      return this.entity_types.length;
    },
    non_compliant_count() {
      return 0;
    },
    at_risk_count() {
      return 0;
    },
    table_title() {
      if (this.selected_status === 'Compliant') {
        return 'Compliant Entities';
      } else if (this.selected_status === 'Non-Compliant') {
        return 'Non-Compliant Entities';
      } else {
        return 'Entities at Risk of Non-Compliance';
      }
    }
  },
  watch: {
    selected_status() {
      this.$nextTick(() => {
        this.init_data_table();
      });
    }
  },
  mounted() {
    this.fetch_entity_types();
  },
  
  methods: {
    async fetch_entity_types() {
      this.entity_types_loading = true;
      try {
        const response = await axios.get(VIEW_ENTITY_TYPE_URL, {
          params: { project_id: this.project_id },
          headers: this.headers
        });

        const data = response.data.data || response.data || [];
        this.entity_types = Array.isArray(data) ? data : [];
        
        // Initialize DataTable after data is loaded
        this.$nextTick(() => {
          this.init_data_table();
        });

      } catch (error) {
        this.entity_types = [];
      } finally {
        this.entity_types_loading = false;
      }
    },
    
    go_to_pending_compliance_checks(row) {
      this.$router.push({
        path: '/trust_compliance',
        query: { 
          entity_type_id: row.entity.id,
          entity_type_name: row.entity.entity_type_name 
        }
      });
    },
    
    init_data_table() {
      this.$nextTick(() => {
        // Destroy existing DataTable if it exists
        if (this.dataTable) {
          this.dataTable.destroy();
          this.dataTable = null;
        }
        
        // Initialize new DataTable
        if (this.entity_types.length > 0) {
          this.dataTable = $('#compliance_table').DataTable({
            destroy: true,
            responsive: true,
          emptyTable: "No data available in table",
          language: {
            info: "", // Capitalized "Entries"
            lengthMenu: "_MENU_&nbsp;&nbsp;Entries per page" // Added non-breaking space
          }
          });
        }
      });
    },
    
    filter_by_status(status) {
      this.selected_status = status;
    }
  },
  
  beforeDestroy() {
    if (this.dataTable) {
      this.dataTable.destroy();
    }
  }
};